
<template>
  <div class="card card-profile mt-2">
    <div class="card-body">
      <div class="text-left">
        <a :href="agreement.file_url" target="_blank">
          <h5>{{ agreement.title }}</h5>
          <div class="h6 font-weight-300">{{ agreement.description }}</div>
        </a>
      </div>
      <div
        class="
          d-flex
          flex-row
          bd-highlight
          align-items-center
          justify-content-end
        "
      >
        <div class="bd-highlight">
          <button
            class="btn btn-link text-danger text-gradient px-3 m-0"
            @click="deleteAgreement"
          >
            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
            Eliminar
          </button>
        </div>
        <div class="bd-highlight">
          <router-link
            :to="`/agreement-card/${agreement.id}`"
            class="btn btn-link text-dark px-3 m-0"
          >
            <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i
            >Editar
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "agreements-table",
  props: {
    agreement: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteAgreement() {
      this.plain
        .delete(`/agreements/${this.agreement.id}`)
        .then(() => {
          this.$parent.deleteItemAgreement(this.agreement.id);
        })
        .catch((error) => {
          console.log("Error al eliminar AGREEMENT", error);
        });
    },
  },
};
</script>